import environment from '@root/core/src/utils/environment';

export const navLinks = [
  {
    text: 'Company',
    href: '/company/',
  },
  environment.incSiteInvestorsLinkEnabled &&
  {
    text: 'Investors',
    href: 'https://ir.joinroot.com/',
  },
  {
    text: 'Corporate Responsibility',
    href: '/corporate-social-responsibility/',
  },
  {
    text: 'Press',
    href: '/press/',
  },
  {
    text: 'Careers',
    href: 'https://inc.joinroot.com/careers/',
  },
].filter(Boolean);
